import { createFileRoute } from '@tanstack/react-router';
import { V2RedirectRoute } from './-journeys-redirects';

function V2Route() {
  const { workspaceId, _splat } = Route.useParams();
  return <V2RedirectRoute workspaceId={workspaceId} splat={_splat ?? ''} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/v2/$')({
  component: V2Route,
});
